module.exports = __webpack_public_path__ + "static/media/halloween.d58e4a40.jpg";